<template>
  
  <v-card :prepend-icon="icon" variant="outlined" :loading="loading">

    <template v-slot:title>

      <v-row>
        <v-col class="text-wrap">
          {{ title }}
        </v-col>
        <v-col v-if="$slots.tools" class="text-right">
          <slot name="tools" />
        </v-col>
      </v-row>

    </template>

    <template v-slot:loader="{ isActive }">
      <v-progress-linear
        :active="isActive"
        height="4"
        indeterminate
        color="secondary"
      />
    </template>

    <template v-slot:text>
      <slot />
    </template>

  </v-card>

</template>

<script setup lang="ts">

interface Props {
  title: string
  icon?: string
  loading: boolean
}

withDefaults(defineProps<Props>(), {
  loading: false,
})

</script>
